const { compose, nth, match, reduce } = require('ramda')
const { pascalCase } = require('change-case')
const req = require.context('.', true, /^(?!.*index).*\/(?!.*test).*\.js$/)

const getModuleName = compose(pascalCase, nth(1), match(/([\w-]*)\.js/))
const mods = req.keys()
const exp = reduce(
  (acc, val) => ({
    ...acc,
    [getModuleName(val)]: req(val).default
  }),
  {},
  mods
)

module.exports = exp



// WEBPACK FOOTER //
// ./src/components/index.js